module.exports = __webpack_public_path__ + "img/cert-front.0128fd9c.png";